export default "__VITE_ASSET__fV4gkORc__"